import { useLocation, useNavigate } from "react-router-dom";

import { contactPaths } from "routes/contact/paths";

/**
 * Opens the Contact form pages. The current location travels as `from`, so
 * Cancel and the back link return to where the user started.
 */
export const useContactNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  return {
    openCreate: preset => navigate(contactPaths.create(preset), { state }),
    openEdit: id => navigate(contactPaths.edit(id), { state }),
  };
};
